import React from 'react';
import { IconProps } from './types';

const SeparatedBars: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1.4166}
    height={size}
    viewBox="0 0 11 10"
  >
    <rect
      x="0.666687"
      y="5"
      width="1.66667"
      height="4.66667"
      rx="0.833333"
      fill={color}
    />
    <rect
      x="5"
      y="2.33334"
      width="1.66667"
      height="7.33333"
      rx="0.833333"
      fill={color}
    />
    <rect
      x="9.33337"
      y="0.333344"
      width="1.66667"
      height="9.33333"
      rx="0.833333"
      fill={color}
    />
  </svg>
);

export default SeparatedBars;
